import { render, staticRenderFns } from "./SincronizacaoInicial.vue?vue&type=template&id=5b9bba3c&scoped=true"
import script from "./SincronizacaoInicial.vue?vue&type=script&lang=js"
export * from "./SincronizacaoInicial.vue?vue&type=script&lang=js"
import style0 from "./SincronizacaoInicial.vue?vue&type=style&index=0&id=5b9bba3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9bba3c",
  null
  
)

export default component.exports